import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonInformationState } from 'models';

const initialState: PersonInformationState = {
  saved: true,
  queue: [],
};

const slicer = createSlice({
  name: 'person-information',
  initialState,
  reducers: {
    setSavedFlag(state, action: PayloadAction<boolean>) {
      state.saved = action.payload;
    },
    addToQueue(state, action: PayloadAction<Function>) {
      state.queue = [action.payload];
    },
    clearQueue(state) {
      state.queue = [];
    },
  },
});

export const { reducer, actions } = slicer;
